// extracted by mini-css-extract-plugin
export default {"message":"yYM3Av8LGk0ZGoAHelsm","info-chenggong":"BLeqlpOZ8scZlwBXIjQb","info-cuowu":"uNpZwGjrjWcyinOS4C0R","info-jinggao":"RnswWiSXGBEKeW9qEBOF"};